import { Component } from 'react'

export default class Prices extends Component {
	render() {
		return <div className="page-content">Prices</div>
	}
}
